import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
import classnames from "classnames";
import { encloseBoldTag } from "utils/strings";
import PictureComponent from "/components/core/picture/picture-component";
import colors from "styles/colors";
import { ConditionalWrapper } from "utils/react";
import DefaultProps from "./default-props";
import { StyledTitle } from "./title.scss";
const Title = (props)=>{
    const { title, titleSize, mobileTitleSize, titleColor, isFirstSegment, titleIcon, titleClassName } = props;
    const mobileSizeClass = mobileTitleSize ? `mobile-${mobileTitleSize}` : null;
    const getTitleStyle = ()=>{
        if (!titleColor) {
            return null;
        }
        const titleStyle = {
            color: colors[titleColor]
        };
        return titleStyle;
    };
    const renderIcon = ()=>{
        return /*#__PURE__*/ _jsx("div", {
            className: classnames("icon-wrapper", titleSize),
            children: /*#__PURE__*/ _jsx(PictureComponent, {
                src: titleIcon,
                alt: "",
                className: "title-icon",
                pictureClass: "picture-icon-wrapper"
            })
        });
    };
    const titleAndIconWrapper = (children)=>/*#__PURE__*/ _jsx("span", {
            className: "title-and-icon-wrapper",
            children: children
        });
    return /*#__PURE__*/ _jsx(StyledTitle, {
        className: "core-title-container",
        children: /*#__PURE__*/ _jsxs(ConditionalWrapper, {
            condition: !!titleIcon,
            wrapper: titleAndIconWrapper,
            children: [
                titleIcon && renderIcon(),
                /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
                    tagName: isFirstSegment ? "h1" : "h2",
                    className: classnames("core-title", titleSize, mobileSizeClass, titleClassName),
                    text: encloseBoldTag(title),
                    style: getTitleStyle()
                })
            ]
        })
    });
};
Title.defaultProps = DefaultProps;
export default Title;
